import { Box } from '@material-ui/core';
import _ from 'lodash';
import { t, Trans } from '@lingui/macro';
import { i18n } from '@lingui/core';
import { NgpLabelValue } from '../../form/NgpLabelValue';
import FormSection from '../../form/FormSection';
import {
    COLLECTOR_MAX_ELEMENTS_DISTRIBUTED,
    COLLECTOR_MAX_ELEMENTS_EMBEDDED,
    COLLECTORS_ADMIN_CREATEDAT_FIELD,
    COLLECTORS_ADMIN_DEVICECOUNT_FIELD,
    COLLECTORS_ADMIN_EMBEDDED_FIELD,
    COLLECTORS_ADMIN_LASTREGISTEREDAT_FIELD,
    COLLECTORS_ADMIN_LASTSEENAT_FIELD,
    COLLECTORS_ADMIN_NETWORK_HOSTNAME_FIELD,
    COLLECTORS_ADMIN_NETWORK_IPV4EXTERNAL_FIELD,
    COLLECTORS_ADMIN_NETWORK_IPV4LOCAL_FIELD,
    COLLECTORS_ADMIN_SOFTWAREVERSIONFMT_FIELD,
    COLLECTORS_ADMIN_UPDATEDAT_FIELD,
} from './CollectorsAdminConstants';
import { dateTimeFormatter } from '../../../utilities';

const MONITORED_ELEMENTS_LABEL_TEXT = i18n._(t`Monitored Elements`);
const HOSTNAME_LABEL_TEXT = i18n._(t`Hostname`);
const INTERNAL_IPV4_LABEL_TEXT = i18n._(t`Internal IPv4`);
const EXTERNAL_IP_LABEL_TEXT = i18n._(t`External IP`);
const VERSION_LABEL_TEXT = i18n._(t`Version`);
const LASTSEEN_LABEL_TEXT = i18n._(t`Last Seen`);
const LASTREGISTERED_LABEL_TEXT = i18n._(t`Last Registered`);
const FIRST_SEEN_LABEL_TEXT = i18n._(t`First Seen`);
const LAST_UPDATED_LABEL_TEXT = i18n._(t`Last Updated`);

function rendermonitoredElements(collector) {
    const deviceCount = _.get(collector, COLLECTORS_ADMIN_DEVICECOUNT_FIELD);
    const maxElementCount = _.get(collector, COLLECTORS_ADMIN_EMBEDDED_FIELD)
        ? COLLECTOR_MAX_ELEMENTS_EMBEDDED
        : COLLECTOR_MAX_ELEMENTS_DISTRIBUTED;
    return `${deviceCount} / ${maxElementCount}`;
}

export default function CollectorDetailReadOnly({ collector }) {
    if (_.isEmpty(collector)) {
        return null;
    }

    const monitoredElements = rendermonitoredElements(collector);

    return (
        <FormSection title={<Trans>Collector Information</Trans>}>
            <Box mt={1.5} mb={0.5}>
                <NgpLabelValue dataLabel={MONITORED_ELEMENTS_LABEL_TEXT} dataValue={monitoredElements} />
                <NgpLabelValue
                    dataLabel={HOSTNAME_LABEL_TEXT}
                    dataValue={_.get(collector, COLLECTORS_ADMIN_NETWORK_HOSTNAME_FIELD)}
                />
                <NgpLabelValue
                    dataLabel={INTERNAL_IPV4_LABEL_TEXT}
                    dataValue={_.get(collector, COLLECTORS_ADMIN_NETWORK_IPV4LOCAL_FIELD)}
                />
                <NgpLabelValue
                    dataLabel={EXTERNAL_IP_LABEL_TEXT}
                    dataValue={_.get(collector, COLLECTORS_ADMIN_NETWORK_IPV4EXTERNAL_FIELD)}
                />
                <NgpLabelValue
                    dataLabel={VERSION_LABEL_TEXT}
                    dataValue={_.get(collector, COLLECTORS_ADMIN_SOFTWAREVERSIONFMT_FIELD)}
                />
                <NgpLabelValue
                    dataLabel={LASTSEEN_LABEL_TEXT}
                    dataValue={dateTimeFormatter(_.get(collector, COLLECTORS_ADMIN_LASTSEENAT_FIELD))}
                />
                <NgpLabelValue
                    dataLabel={LASTREGISTERED_LABEL_TEXT}
                    dataValue={dateTimeFormatter(_.get(collector, COLLECTORS_ADMIN_LASTREGISTEREDAT_FIELD))}
                />
                <NgpLabelValue
                    dataLabel={FIRST_SEEN_LABEL_TEXT}
                    dataValue={dateTimeFormatter(_.get(collector, COLLECTORS_ADMIN_CREATEDAT_FIELD))}
                />
                <NgpLabelValue
                    dataLabel={LAST_UPDATED_LABEL_TEXT}
                    dataValue={dateTimeFormatter(_.get(collector, COLLECTORS_ADMIN_UPDATEDAT_FIELD))}
                />
            </Box>
        </FormSection>
    );
}
